export const Logo = (props) => {
  return (
    <svg
      width="42"
      height="32"
      viewBox="0 0 42 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7215_70224)">
        <path
          d="M13.2216 4.92228C13.2216 5.10116 13.1352 5.20092 12.9611 5.22156C12.937 5.225 9.53842 5.22614 9.51173 5.22614C9.48377 5.22614 9.30837 5.24564 8.98428 5.28233C8.66019 5.32132 8.31576 5.42222 7.95099 5.58734C7.58623 5.75246 7.24816 6.01849 6.93931 6.38657C6.63047 6.75465 6.47541 7.28097 6.47541 7.96553V14.7366H12.8798C13.1047 14.7366 13.2178 14.826 13.2178 15.0026C13.2178 15.2067 13.1047 15.3076 12.8798 15.3076H6.47541V26.6023C6.47541 26.8064 6.37755 26.9073 6.18055 26.9073C5.95559 26.9073 5.84375 26.8064 5.84375 26.6023V7.96667C5.84375 7.15483 6.03312 6.52761 6.41187 6.08385C6.79188 5.64009 7.20749 5.311 7.65613 5.09428C8.10605 4.8787 8.72628 4.73308 9.51173 4.65625C9.53842 4.65625 12.9357 4.65625 12.9586 4.65969C13.1352 4.67804 13.2229 4.76633 13.2229 4.92228H13.2216Z"
          fill="white"
        />
        <path
          d="M6.17698 27.5686C5.54785 27.5686 5.10938 27.1718 5.10938 26.6054V7.96861C5.10938 7.01229 5.35086 6.24402 5.82874 5.68331C6.27103 5.16731 6.76797 4.774 7.30813 4.51485C7.84828 4.25685 8.54223 4.08944 9.42935 4.00344L9.50688 4C12.9677 4 12.9918 4.00229 13.044 4.00917C13.5803 4.06421 13.9476 4.43229 13.9476 4.92536C13.9476 5.41843 13.5892 5.81173 13.0554 5.87824C13.002 5.88512 12.969 5.88856 9.5323 5.88856C9.46748 5.89429 9.31497 5.91149 9.07349 5.94016C8.83328 5.96882 8.56383 6.05024 8.27278 6.18096C8.01097 6.29906 7.75551 6.50432 7.51529 6.78869C7.30686 7.03752 7.2001 7.43426 7.2001 7.96861V14.0803H12.8749C13.504 14.0803 13.9425 14.461 13.9425 15.0057C13.9425 15.5504 13.5028 15.9689 12.8749 15.9689H7.2001V26.6042C7.2001 27.1718 6.77814 27.5674 6.17571 27.5674L6.17698 27.5686Z"
          fill="white"
        />
        <path
          d="M34.9864 4.6875C35.2114 4.6875 35.3245 4.77694 35.3245 4.95467V12.0296C35.2686 12.4607 35.1694 12.8667 35.0296 13.2474C34.8885 13.5776 34.6776 13.9136 34.3967 14.2553C34.1158 14.5981 33.7218 14.871 33.2172 15.0729C33.7231 15.2758 34.1997 15.6061 34.6509 16.0624C35.1008 16.5188 35.3258 17.1919 35.3258 18.0794V26.6347C35.3258 26.8376 35.2126 26.9385 34.9877 26.9385C34.7627 26.9385 34.6509 26.8376 34.6509 26.6347V18.0794C34.6509 17.3948 34.4958 16.8685 34.187 16.5004C33.8781 16.1335 33.5401 15.8663 33.1753 15.7012C32.8093 15.5361 32.4648 15.4352 32.142 15.3974C31.8192 15.3595 31.6425 15.34 31.6146 15.34H28.5782V26.6358C28.5782 26.8388 28.4791 26.9397 28.2821 26.9397C28.0572 26.9397 27.9453 26.8388 27.9453 26.6358V4.95467C27.9453 4.77694 28.0572 4.6875 28.2821 4.6875C28.4791 4.6875 28.5782 4.77694 28.5782 4.95467V14.7701H31.6146C32.3733 14.7701 32.9567 14.6314 33.3647 14.3516C33.7714 14.073 34.0675 13.7679 34.2505 13.4377C34.4335 13.1086 34.5454 12.7979 34.5886 12.5055C34.6305 12.2142 34.6509 12.0548 34.6509 12.0296V4.95467C34.6509 4.77694 34.764 4.6875 34.9877 4.6875H34.9864Z"
          fill="white"
        />
        <path
          d="M34.9854 27.5998C34.3562 27.5998 33.9178 27.2042 33.9178 26.6378V18.0825C33.9178 17.5481 33.811 17.1514 33.6013 16.9003C33.3624 16.6171 33.1082 16.4118 32.8438 16.2925C32.554 16.1618 32.2833 16.0804 32.0431 16.0529C31.8029 16.0242 31.6491 16.007 31.583 16.0013H29.3042V26.6378C29.3042 27.2042 28.8822 27.5998 28.2785 27.5998C27.6748 27.5998 27.2109 27.2042 27.2109 26.6378V4.95661C27.2109 4.41194 27.6494 4.03125 28.2785 4.03125C28.9077 4.03125 29.3042 4.41194 29.3042 4.95661V14.1127H31.6097C32.202 14.1127 32.643 14.0176 32.9175 13.8284C33.234 13.6116 33.4602 13.3812 33.5924 13.1449C33.7373 12.8847 33.8275 12.6416 33.8593 12.4214C33.8898 12.2058 33.9089 12.0671 33.9152 12.0086V4.95661C33.9152 4.41194 34.3537 4.03125 34.9828 4.03125C35.612 4.03125 36.0504 4.41194 36.0504 4.95661L36.0453 12.1084C35.9843 12.5796 35.8738 13.0326 35.7174 13.4568C35.5408 13.8719 35.2955 14.2629 34.9777 14.6505C34.8545 14.8019 34.7134 14.9418 34.5558 15.0713C34.7744 15.2353 34.9854 15.4199 35.1887 15.6275C35.7594 16.2065 36.0492 17.0333 36.0492 18.0825V26.6378C36.0492 27.2042 35.6094 27.5998 34.9816 27.5998H34.9854Z"
          fill="white"
        />
        <path
          d="M23.8059 13.6757C23.947 13.397 24.0537 13.1367 24.1236 12.8959C24.1923 12.6551 24.2418 12.3696 24.2711 12.0394V8.0077C24.1872 7.29791 24.0245 6.73375 23.7856 6.31407C23.5479 5.89554 23.1755 5.51485 22.6684 5.17199C22.2197 4.86927 21.6097 4.70874 20.856 4.6732C20.8179 4.66861 20.7886 4.66173 20.7492 4.65829C20.7162 4.65829 17.2109 4.6537 17.1855 4.65829C16.9885 4.70989 16.8906 4.8108 16.8906 4.9633V26.641C16.8906 26.7935 16.9885 26.8956 17.1855 26.946C17.2084 26.9495 20.7454 26.946 20.7492 26.946C20.8052 26.9414 20.8522 26.9311 20.9018 26.9242C21.8334 26.8669 22.5972 26.5917 23.1742 26.0723C23.4538 25.8189 23.6648 25.5528 23.8046 25.273C23.9457 24.9944 24.0525 24.7341 24.1224 24.4933C24.191 24.2525 24.2406 23.967 24.2698 23.6368V18.088C24.2698 17.2005 24.0436 16.5274 23.5936 16.0711C23.145 15.6147 22.6671 15.2856 22.1613 15.0815C22.554 14.929 22.8921 14.7272 23.1742 14.4726C23.4538 14.2192 23.6648 13.9532 23.8046 13.6734L23.8059 13.6757ZM23.131 16.5102C23.4399 16.8783 23.5949 17.4046 23.5949 18.0892V23.6379C23.5949 23.8661 23.553 24.108 23.4691 24.3614C23.4132 24.5656 23.328 24.78 23.2149 25.0082C23.1031 25.2364 22.934 25.4531 22.7091 25.6549C22.1753 26.1365 21.4584 26.3773 20.5599 26.3773C20.5573 26.3773 18.1184 26.336 17.5248 26.3314V15.3487H20.5599C20.5866 15.3487 20.7632 15.3681 21.0873 15.406C21.4101 15.4438 21.7546 15.5459 22.1193 15.7099C22.4854 15.875 22.8234 16.141 23.1323 16.5091L23.131 16.5102ZM20.5586 14.7409H17.5236V5.27405C18.0993 5.26831 19.4669 5.2729 20.2065 5.2729C20.2065 5.27749 20.5916 5.2729 20.631 5.2729C21.3529 5.28207 21.9147 5.41853 22.31 5.68799C22.7167 5.96663 23.0115 6.27165 23.1946 6.60189C23.3763 6.93098 23.4894 7.24173 23.5326 7.53413C23.5746 7.82538 23.5949 7.98477 23.5949 8.00999V12.0417C23.5949 12.2699 23.553 12.5118 23.4691 12.7652C23.4132 12.9682 23.328 13.1837 23.2149 13.4119C23.1031 13.6401 22.934 13.8557 22.7091 14.0587C22.2032 14.515 21.4877 14.7432 20.5599 14.7432L20.5586 14.7409Z"
          fill="white"
        />
        <path
          d="M18.2052 27.6073C17.1325 27.6073 17.1122 27.6038 17.0537 27.5935L16.9876 27.5798C16.4793 27.449 16.1641 27.089 16.1641 26.6418V4.96407C16.1641 4.51802 16.4793 4.15797 16.9864 4.0261L17.0347 4.01578C17.1016 4.00278 18.3171 3.99782 20.681 4.00087L20.8323 4.00546C20.8717 4.0089 20.906 4.01463 20.9403 4.02037C21.8325 4.06738 22.5621 4.27837 23.1086 4.64645C23.7034 5.04893 24.1495 5.50874 24.438 6.01442C24.7214 6.51207 24.9057 7.14159 24.9997 7.93852L25.0036 8.00847L25.001 12.0929C24.968 12.4598 24.9121 12.7855 24.832 13.0618C24.7519 13.337 24.635 13.626 24.4736 13.9482C24.2982 14.2968 24.0364 14.6305 23.6957 14.9401C23.6398 14.9905 23.5814 15.0398 23.5216 15.0868C23.7364 15.2485 23.9436 15.432 24.1444 15.6349C24.7151 16.214 25.0048 17.0408 25.0048 18.09L25.0023 23.6914C24.9692 24.0584 24.9133 24.384 24.8333 24.6604C24.7532 24.9367 24.6363 25.2268 24.4736 25.5479C24.2995 25.8953 24.0376 26.229 23.6957 26.5386C23.0094 27.1566 22.1007 27.5052 20.9924 27.5809C20.9225 27.5924 20.8768 27.5981 20.8259 27.6027L20.7535 27.6061C19.5473 27.6073 18.7441 27.6084 18.2065 27.6084L18.2052 27.6073ZM18.2573 25.6797C19.6643 25.6912 20.2705 25.7027 20.5628 25.7233V25.7199C21.267 25.7199 21.802 25.5467 22.196 25.1901C22.3574 25.0445 22.4769 24.8943 22.5506 24.7429C22.6472 24.5491 22.7184 24.368 22.7641 24.2017C22.8366 23.9827 22.8684 23.8038 22.8684 23.6387V18.09C22.8684 17.5545 22.7629 17.1577 22.5532 16.9089C22.3142 16.6245 22.06 16.4204 21.7957 16.3012C21.5059 16.1704 21.2364 16.089 20.9962 16.0615C20.756 16.0328 20.6022 16.0156 20.5362 16.0099H18.2586V25.6809L18.2573 25.6797ZM18.2573 14.0824H20.5628C21.2949 14.0824 21.8287 13.9207 22.196 13.5904C22.3574 13.4448 22.4769 13.2946 22.5506 13.1444C22.6472 12.9495 22.7184 12.7694 22.7641 12.6032C22.8366 12.3853 22.8684 12.2053 22.8684 12.0401V8.0314C22.862 7.97292 22.8429 7.83418 22.8124 7.61631C22.7807 7.40188 22.6904 7.15879 22.5455 6.89506C22.4134 6.65884 22.1871 6.42837 21.8719 6.21165C21.6101 6.03277 21.1907 5.93874 20.6264 5.93186C20.4548 5.93301 20.3214 5.93415 20.2121 5.93071V5.93301H19.4774C19.0771 5.93301 18.6399 5.93071 18.2599 5.93186V14.0847L18.2573 14.0824Z"
          fill="white"
        />
        <path
          d="M4.50626 31.6684C4.08048 31.6684 3.80469 31.4196 3.80469 31.0343C3.80469 30.672 4.08048 30.4392 4.50626 30.4392H37.607C38.2806 30.4392 38.7954 30.3211 39.1373 30.0872C39.4969 29.8407 39.7588 29.5723 39.9164 29.2891C40.079 28.9956 40.1807 28.7169 40.2176 28.4612C40.2544 28.2055 40.2748 28.0564 40.2786 28.0152C40.2786 27.998 40.2786 24.9341 40.2837 24.8871C40.3345 24.5499 40.6014 24.3516 40.9801 24.3516C41.3589 24.3516 41.5915 24.5545 41.6347 24.8813C41.6372 24.8985 41.641 24.9237 41.641 28.0289L41.6385 28.0645C41.5495 28.8132 41.3729 29.4175 41.1136 29.8579C40.8518 30.3028 40.4489 30.7156 39.9176 31.0859C39.3622 31.4724 38.5844 31.6684 37.607 31.6684H4.50626Z"
          fill="#F15B29"
        />
        <path
          d="M40.9777 24.6816C41.1506 24.6816 41.2484 24.7607 41.2688 24.9201C41.2713 24.9396 41.2726 28.0058 41.2726 28.0299C41.1887 28.7397 41.026 29.2981 40.7883 29.704C40.5494 30.1099 40.1834 30.4838 39.6915 30.8266C39.1996 31.1683 38.5032 31.3403 37.6046 31.3403H4.50383C4.27887 31.3403 4.16703 31.2383 4.16703 31.0364C4.16703 30.8587 4.27887 30.7704 4.50383 30.7704H37.6046C38.3634 30.7704 38.9467 30.6317 39.3547 30.3519C39.7614 30.0732 40.0563 29.7694 40.2393 29.4391C40.4223 29.11 40.5342 28.7982 40.5761 28.5069C40.618 28.2156 40.6396 28.0574 40.6396 28.0322C40.6396 28.007 40.6422 24.9408 40.6435 24.919C40.6676 24.7619 40.7782 24.6839 40.9764 24.6839M40.9777 24.0234C40.4198 24.0234 39.9953 24.3457 39.9216 24.8261L39.919 24.8422V24.8582C39.9101 24.9259 39.9101 27.4359 39.9101 28.0047C39.9038 28.0631 39.8847 28.2019 39.8529 28.4186C39.8212 28.6376 39.7322 28.8807 39.5873 29.141C39.4551 29.3784 39.2289 29.6077 38.9137 29.8244C38.6379 30.0136 38.1969 30.1088 37.6046 30.1088H4.50383C3.87598 30.1088 3.4375 30.4895 3.4375 31.0342C3.4375 31.5788 3.87598 31.9973 4.50383 31.9973H37.6046C38.6646 31.9973 39.5174 31.7783 40.1376 31.3472C40.7108 30.947 41.1468 30.4987 41.4327 30.0125C41.7187 29.5274 41.9042 28.9014 41.9983 28.0998L42.0021 28.0654V28.0299C42.0021 24.9029 41.9996 24.8892 41.9919 24.8364C41.9297 24.3537 41.5204 24.0234 40.9764 24.0234H40.9777Z"
          fill="#F15B29"
        />
        <path
          d="M1.02808 7.645C0.667133 7.645 0.416755 7.44204 0.373542 7.11524C0.371 7.09804 0.367188 7.07281 0.367188 3.96764L0.369729 3.9321C0.458696 3.18332 0.635359 2.58018 0.894634 2.13871C1.15772 1.6938 1.55934 1.27986 2.0906 0.909484C2.64601 0.523058 3.42384 0.328125 4.4012 0.328125H37.502C37.929 0.328125 38.2048 0.576951 38.2048 0.962231C38.2048 1.32458 37.929 1.55735 37.502 1.55735H4.4012C3.72759 1.55735 3.21286 1.67546 2.87224 1.90938C2.51129 2.15591 2.24947 2.42423 2.09187 2.70746C1.92919 3.0033 1.82752 3.28194 1.79066 3.53535C1.7538 3.79106 1.73347 3.93898 1.72965 3.9814C1.72965 6.02591 1.72711 7.08657 1.7233 7.12097C1.67246 7.44663 1.40683 7.64615 1.02808 7.64615V7.645Z"
          fill="#F15B29"
        />
        <path
          d="M37.4995 0.659333C37.7245 0.659333 37.8364 0.760239 37.8364 0.963199C37.8364 1.14093 37.7245 1.22923 37.4995 1.22923H4.39878C3.64002 1.22923 3.05665 1.36797 2.64867 1.64776C2.24197 1.9264 1.94583 2.23026 1.76282 2.5605C1.5798 2.89074 1.46795 3.20149 1.42601 3.49274C1.38407 3.784 1.36246 3.94224 1.36246 3.96861C1.36246 3.99269 1.36119 7.06002 1.35865 7.08066C1.3345 7.23775 1.22393 7.31573 1.02566 7.31573C0.852811 7.31573 0.754948 7.23661 0.734612 7.07722C0.732071 7.05773 0.7308 3.99154 0.7308 3.96861C0.814683 3.25882 0.977365 2.7004 1.2163 2.29448C1.45524 1.88856 1.82128 1.51475 2.31314 1.17189C2.805 0.830186 3.50148 0.659333 4.40005 0.659333H37.5008M37.4995 0.00114667H4.39878C3.3388 0.00114667 2.48726 0.22016 1.86576 0.651306C1.29256 1.05035 0.857895 1.49984 0.570659 1.98602C0.284694 2.47221 0.0991345 3.09829 0.00381287 3.89981L0 3.93421V3.96976C0 7.09671 0.00254191 7.11047 0.0101676 7.16322C0.0724445 7.64597 0.481692 7.97621 1.02566 7.97621C1.56963 7.97621 2.00811 7.65285 2.08183 7.17239C2.08945 7.11965 2.09326 7.08869 2.09326 3.99269C2.09962 3.93421 2.11868 3.79546 2.15046 3.57874C2.18223 3.36202 2.2712 3.11778 2.41736 2.8552C2.54827 2.61898 2.77577 2.38965 3.09096 2.17293C3.36676 1.98373 3.80651 1.88856 4.40005 1.88856H37.5008C38.1287 1.88856 38.5684 1.50787 38.5684 0.963199C38.5684 0.418533 38.1299 0 37.5008 0L37.4995 0.00114667Z"
          fill="#F15B29"
        />
        <path
          d="M13.1416 10.3258C13.1416 11.4552 12.1274 12.3703 10.8755 12.3703C9.6236 12.3703 8.60938 11.4552 8.60938 10.3258C8.60938 9.19629 9.6236 8.28125 10.8755 8.28125C12.1274 8.28125 13.1416 9.19629 13.1416 10.3258Z"
          fill="#F15B29"
        />
        <path
          d="M10.8743 12.7015C9.42291 12.7015 8.24219 11.6362 8.24219 10.3279C8.24219 9.01952 9.42291 7.95312 10.8743 7.95312C12.3258 7.95312 13.5052 9.01838 13.5052 10.3279C13.5052 11.6374 12.3245 12.7015 10.8743 12.7015ZM10.8743 8.61246C9.8258 8.61246 8.97299 9.38187 8.97299 10.3279C8.97299 11.2739 9.8258 12.0433 10.8743 12.0433C11.9229 12.0433 12.7757 11.2739 12.7757 10.3279C12.7757 9.38187 11.9229 8.61246 10.8743 8.61246Z"
          fill="#F7941D"
        />
        <path
          d="M13.1416 20.9586C13.1416 22.088 12.1274 23.0031 10.8755 23.0031C9.6236 23.0031 8.60938 22.088 8.60938 20.9586C8.60938 19.8291 9.6236 18.9141 10.8755 18.9141C12.1274 18.9141 13.1416 19.8291 13.1416 20.9586Z"
          fill="#F15B29"
        />
        <path
          d="M10.8743 23.3343C9.42291 23.3343 8.24219 22.269 8.24219 20.9607C8.24219 19.6523 9.42291 18.5859 10.8743 18.5859C12.3258 18.5859 13.5052 19.6512 13.5052 20.9607C13.5052 22.2702 12.3245 23.3343 10.8743 23.3343ZM10.8743 19.2453C9.8258 19.2453 8.97299 20.0147 8.97299 20.9607C8.97299 21.9067 9.8258 22.6761 10.8743 22.6761C11.9229 22.6761 12.7757 21.9067 12.7757 20.9607C12.7757 20.0147 11.9229 19.2453 10.8743 19.2453Z"
          fill="#F7941D"
        />
      </g>
      <defs>
        <clipPath id="clip0_7215_70224">
          <rect width="42" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RippleLoaderSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="200px"
    height="200px"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
    fill="none"
  >
    <circle
      cx="50"
      cy="50"
      r="0"
      fill="none"
      className="stroke-themeBtn"
      strokeWidth="2"
    >
      <animate
        attributeName="r"
        repeatCount="indefinite"
        dur="1s"
        values="0;40"
        keyTimes="0;1"
        keySplines="0 0.2 0.8 1"
        calcMode="spline"
        begin="0s"
      ></animate>
      <animate
        attributeName="opacity"
        repeatCount="indefinite"
        dur="1s"
        values="1;0"
        keyTimes="0;1"
        keySplines="0.2 0 0.8 1"
        calcMode="spline"
        begin="0s"
      ></animate>
    </circle>
    <circle
      cx="50"
      cy="50"
      r="0"
      fill="none"
      className="stroke-themeBtn"
      strokeWidth="2"
    >
      <animate
        attributeName="r"
        repeatCount="indefinite"
        dur="1s"
        values="0;40"
        keyTimes="0;1"
        keySplines="0 0.2 0.8 1"
        calcMode="spline"
        begin="-0.5s"
      ></animate>
      <animate
        attributeName="opacity"
        repeatCount="indefinite"
        dur="1s"
        values="1;0"
        keyTimes="0;1"
        keySplines="0.2 0 0.8 1"
        calcMode="spline"
        begin="-0.5s"
      ></animate>
    </circle>
  </svg>
);

export const LoaderSvg = () => {
  return (
    <svg
      aria-hidden="true"
      role="status"
      className="inline mr-3 w-4 h-4 text-white animate-spin"
      viewBox="0 0 100 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="#E5E7EB"
      ></path>
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="currentColor"
      ></path>
    </svg>
  );
};

export const Notifications = (props) => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 19.75C9.1 19.75 10 18.85 10 17.75H6C6 18.85 6.89 19.75 8 19.75ZM14 13.75V8.75C14 5.68 12.36 3.11 9.5 2.43V1.75C9.5 0.92 8.83 0.25 8 0.25C7.17 0.25 6.5 0.92 6.5 1.75V2.43C3.63 3.11 2 5.67 2 8.75V13.75L0 15.75V16.75H16V15.75L14 13.75Z"
        fill="white"
      />
    </svg>
  );
};

export const Avatar = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="32" height="32" rx="4" fill="#BDBDBD" />
      <path
        d="M16 16C18.21 16 20 14.21 20 12C20 9.79 18.21 8 16 8C13.79 8 12 9.79 12 12C12 14.21 13.79 16 16 16ZM16 18C13.33 18 8 19.34 8 22V24H24V22C24 19.34 18.67 18 16 18Z"
        fill="white"
      />
    </svg>
  );
};

export const MyProfile = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};

export const LogOut = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 7L15.59 8.41L18.17 11H8V13H18.17L15.59 15.58L17 17L22 12L17 7ZM4 5H12V3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H12V19H4V5Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};

export const OutVector = (props) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 4L13.59 5.41L16.17 8H6V10H16.17L13.59 12.58L15 14L20 9L15 4ZM2 2H10V0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H10V16H2V2Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};

export const Plus = (props) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.8334 6.83464H6.83341V11.8346H5.16675V6.83464H0.166748V5.16797H5.16675V0.167969H6.83341V5.16797H11.8334V6.83464Z"
        fill="white"
        {...props}
      />
    </svg>
  );
};

export const Minus = (props) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12.5 6.875H2.5V8.125H12.5V6.875Z" fill="black" />
    </svg>
  );
};

export const DownArrowAction = ({ className = "" }) => {
  return (
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.59 0.296875L6 4.87687L1.41 0.296875L0 1.70687L6 7.70687L12 1.70687L10.59 0.296875Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Search = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.7549 11.2539H11.9649L11.6849 10.9839C12.6649 9.84391 13.2549 8.36391 13.2549 6.75391C13.2549 3.16391 10.3449 0.253906 6.75488 0.253906C3.16488 0.253906 0.254883 3.16391 0.254883 6.75391C0.254883 10.3439 3.16488 13.2539 6.75488 13.2539C8.36488 13.2539 9.84488 12.6639 10.9849 11.6839L11.2549 11.9639V12.7539L16.2549 17.7439L17.7449 16.2539L12.7549 11.2539ZM6.75488 11.2539C4.26488 11.2539 2.25488 9.24391 2.25488 6.75391C2.25488 4.26391 4.26488 2.25391 6.75488 2.25391C9.24488 2.25391 11.2549 4.26391 11.2549 6.75391C11.2549 9.24391 9.24488 11.2539 6.75488 11.2539Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};

export const Sales = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 9.49219H2.5V18.9922H6.5V9.49219Z"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 17.4922C4.77614 17.4922 5 17.2683 5 16.9922C5 16.716 4.77614 16.4922 4.5 16.4922C4.22386 16.4922 4 16.716 4 16.9922C4 17.2683 4.22386 17.4922 4.5 17.4922Z"
        fill="black"
        fillOpacity="0.54"
      />
      <path
        d="M18.3 12.24C18.2641 12.1128 18.2678 11.9776 18.3107 11.8525C18.3535 11.7274 18.4335 11.6184 18.54 11.54C18.7033 11.3982 18.8303 11.2193 18.9103 11.0184C18.9903 10.8174 19.0211 10.6003 19 10.385C19.0028 10.0396 18.8759 9.70569 18.6445 9.44927C18.4131 9.19284 18.0939 9.03253 17.75 9H11.5"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 18H7.735C8.17123 18.2058 8.62462 18.3731 9.09 18.5"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 13.5C14.2089 13.5 13.4355 13.7346 12.7777 14.1741C12.1199 14.6136 11.6072 15.2384 11.3045 15.9693C11.0017 16.7002 10.9225 17.5044 11.0769 18.2804C11.2312 19.0563 11.6122 19.769 12.1716 20.3284C12.731 20.8878 13.4437 21.2688 14.2196 21.4231C14.9956 21.5775 15.7998 21.4983 16.5307 21.1955C17.2616 20.8928 17.8864 20.3801 18.3259 19.7223C18.7654 19.0645 19 18.2911 19 17.5C19 16.4391 18.5786 15.4217 17.8284 14.6716C17.0783 13.9214 16.0609 13.5 15 13.5Z"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M13 17L14.5 18.5L17 16"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M11.7859 7V4.5C11.7859 3.83696 11.5225 3.20107 11.0537 2.73223C10.5849 2.26339 9.94898 2 9.28594 2V6.5L8.30094 9.095C8.13093 9.5513 8.00045 10.0214 7.91094 10.5H6.58594"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const RevenueIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 7.5H2.5V3.5H21.5V7.5H19"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M19 3.5V19.5C19 19.7652 18.8946 20.0196 18.7071 20.2071C18.5196 20.3946 18.2652 20.5 18 20.5H6C5.73478 20.5 5.48043 20.3946 5.29289 20.2071C5.10536 20.0196 5 19.7652 5 19.5V3.5"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12 14.5C14.2091 14.5 16 12.933 16 11C16 9.067 14.2091 7.5 12 7.5C9.79086 7.5 8 9.067 8 11C8 12.933 9.79086 14.5 12 14.5Z"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 12.5C13.3284 12.5 14 11.8284 14 11C14 10.1716 13.3284 9.5 12.5 9.5C11.6716 9.5 11 10.1716 11 11C11 11.8284 11.6716 12.5 12.5 12.5Z"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="1.94"
        strokeLinejoin="round"
      />
      <path
        d="M9.35156 8.10156C9.8496 8.39858 10.2627 8.81891 10.551 9.32202C10.8394 9.82512 10.9932 10.394 10.9978 10.9739C11.0023 11.5538 10.8573 12.125 10.5769 12.6325C10.2964 13.1401 9.8899 13.5668 9.39656 13.8716"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M15 18.5C15 17.9696 15.2107 17.4609 15.5858 17.0858C15.9609 16.7107 16.4696 16.5 17 16.5"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 16.5C7.53043 16.5 8.03914 16.7107 8.41421 17.0858C8.78929 17.4609 9 17.9696 9 18.5"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Invoice = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 4L14.5 2L12 4L9.5 2L7 4L4.5 2V22L7 20L9.5 22L12 20L14.5 22L17 20L19.5 22V2L17 4Z"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 7.5H15.5"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 13.5H14"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M15 13.5H18"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 9.5H18"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 11.5H18"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 15.5H18"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 7.5H18"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M8 9.5V14.5"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DropUp = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.66406 14L12.6641 9L17.6641 14H7.66406Z" fill="#54CEB8" />
    </svg>
  );
};

export const DropDwn = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="#F6A78D" />
    </svg>
  );
};

export const Breadcrumbs = (props) => {
  return (
    <svg
      width="7"
      height="19"
      viewBox="0 0 7 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.672 0.927999L2.288 18.72H0.848L5.216 0.927999H6.672Z"
        fill="black"
        fillOpacity="0.6"
      />
    </svg>
  );
};

export const Eye = (props) => {
  return (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 0.5C6 0.5 1.73 3.61 0 8C1.73 12.39 6 15.5 11 15.5C16 15.5 20.27 12.39 22 8C20.27 3.61 16 0.5 11 0.5ZM11 13C8.24 13 6 10.76 6 8C6 5.24 8.24 3 11 3C13.76 3 16 5.24 16 8C16 10.76 13.76 13 11 13ZM11 5C9.34 5 8 6.34 8 8C8 9.66 9.34 11 11 11C12.66 11 14 9.66 14 8C14 6.34 12.66 5 11 5Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};

export const EyeSlash = (props) => {
  return (
    <svg
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 2C6 2 1.73 5.11 0 9.5C1.73 13.89 6 17 11 17C16 17 20.27 13.89 22 9.5C20.27 5.11 16 2 11 2ZM11 14.5C8.24 14.5 6 12.26 6 9.5C6 6.74 8.24 4.5 11 4.5C13.76 4.5 16 6.74 16 9.5C16 12.26 13.76 14.5 11 14.5ZM11 6.5C9.34 6.5 8 7.84 8 9.5C8 11.16 9.34 12.5 11 12.5C12.66 12.5 14 11.16 14 9.5C14 7.84 12.66 6.5 11 6.5Z"
        fill="black"
        fillOpacity="0.54"
      />
      <path
        d="M18 2L4 17"
        stroke="#707070"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const MailBox = (props) => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM18 4L10 9L2 4V2L10 7L18 2V4Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};

export const MoreVert = (props) => {
  return (
    <svg
      width="4"
      height="14"
      viewBox="0 0 4 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.99992 3.66732C2.91659 3.66732 3.66659 2.91732 3.66659 2.00065C3.66659 1.08398 2.91659 0.333984 1.99992 0.333984C1.08325 0.333984 0.333252 1.08398 0.333252 2.00065C0.333252 2.91732 1.08325 3.66732 1.99992 3.66732ZM1.99992 5.33398C1.08325 5.33398 0.333252 6.08398 0.333252 7.00065C0.333252 7.91732 1.08325 8.66732 1.99992 8.66732C2.91659 8.66732 3.66659 7.91732 3.66659 7.00065C3.66659 6.08398 2.91659 5.33398 1.99992 5.33398ZM1.99992 10.334C1.08325 10.334 0.333252 11.084 0.333252 12.0007C0.333252 12.9173 1.08325 13.6673 1.99992 13.6673C2.91659 13.6673 3.66659 12.9173 3.66659 12.0007C3.66659 11.084 2.91659 10.334 1.99992 10.334Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};

export const SortDownArrow = (props) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 6L10.9425 4.9425L6.75 9.1275V0H5.25V9.1275L1.065 4.935L0 6L6 12L12 6Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};

export const TableLeft = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
    >
      <path
        d="M7.70687 1.41L6.29688 0L0.296875 6L6.29688 12L7.70687 10.59L3.12687 6L7.70687 1.41Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};

export const TableRight = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
    >
      <path
        d="M1.70687 0L0.296875 1.41L4.87687 6L0.296875 10.59L1.70687 12L7.70687 6L1.70687 0Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};

export const TableDown = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
    >
      <path
        d="M10.59 0.296875L6 4.87687L1.41 0.296875L0 1.70687L6 7.70687L12 1.70687L10.59 0.296875Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};

export const TableUp = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
    >
      <path
        d="M6 0.296875L0 6.29688L1.41 7.70687L6 3.12687L10.59 7.70687L12 6.29688L6 0.296875Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};

export const Bell = () => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 19.75C9.1 19.75 10 18.85 10 17.75H6C6 18.85 6.89 19.75 8 19.75ZM14 13.75V8.75C14 5.68 12.36 3.11 9.5 2.43V1.75C9.5 0.92 8.83 0.25 8 0.25C7.17 0.25 6.5 0.92 6.5 1.75V2.43C3.63 3.11 2 5.67 2 8.75V13.75L0 15.75V16.75H16V15.75L14 13.75Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};

export const Electronic = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
  >
    <g transform="scale(1.8) translate(1.5, 1)">
      <path
        d="M4.48047 1V6.5H5.98047V11L9.48047 5H7.48047L8.98047 1H4.48047Z"
        fill="black"
        fillOpacity="0.54"
      />
    </g>
  </svg>
);

export const Default = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M8 2.5L14 7V16H2V7L8 2.5ZM8 0L0 6V18H16V6L8 0ZM7.5 6.5V9.5H7V6.5H6V9.5H5.5V6.5H4.5V9.5C4.5 10.33 5.17 11 6 11V15H7V11C7.83 11 8.5 10.33 8.5 9.5V6.5H7.5ZM9 8.5V11.5H10V15H11V6.5C9.9 6.5 9 7.4 9 8.5Z"
      fill="black"
      fillOpacity="0.54"
    />
  </svg>
);

export const Gas = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M15.48 11.3462C13.91 7.26623 8.32 7.04623 9.67 1.11623C9.77 0.676234 9.3 0.336234 8.92 0.566234C5.29 2.70623 2.68 6.99623 4.87 12.6162C5.05 13.0762 4.51 13.5062 4.12 13.2062C2.31 11.8362 2.12 9.86623 2.28 8.45623C2.34 7.93623 1.66 7.68623 1.37 8.11623C0.69 9.15623 0 10.8362 0 13.3662C0.38 18.9662 5.11 20.6862 6.81 20.9062C9.24 21.2162 11.87 20.7662 13.76 19.0362C15.84 17.1062 16.6 14.0262 15.48 11.3462ZM6.2 16.3762C7.64 16.0262 8.38 14.9862 8.58 14.0662C8.91 12.6362 7.62 11.2362 8.49 8.97623C8.82 10.8462 11.76 12.0162 11.76 14.0562C11.84 16.5862 9.1 18.7562 6.2 16.3762Z"
      fill="black"
      fillOpacity="0.54"
    />
  </svg>
);

export const Plumbing = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M10 0L0 9H3V17H17V9H20L10 0ZM5 15V7.19L10 2.69L15 7.19V15H5ZM12 11C12 12.1 11.1 13 10 13C8.9 13 8 12.1 8 11C8 9.9 10 7 10 7C10 7 12 9.9 12 11Z"
      fill="black"
      fillOpacity="0.54"
    />
  </svg>
);

export const Exhaust = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M12.5 14C12.5 15.65 11.15 17 9.5 17C7.85 17 6.5 15.65 6.5 14H8.5C8.5 14.55 8.95 15 9.5 15C10.05 15 10.5 14.55 10.5 14C10.5 13.45 10.05 13 9.5 13H0V11H9.5C11.15 11 12.5 12.35 12.5 14ZM17 3.5C17 1.57 15.43 0 13.5 0C11.57 0 10 1.57 10 3.5H12C12 2.67 12.67 2 13.5 2C14.33 2 15 2.67 15 3.5C15 4.33 14.33 5 13.5 5H0V7H13.5C15.43 7 17 5.43 17 3.5ZM16.5 8H0V10H16.5C17.33 10 18 10.67 18 11.5C18 12.33 17.33 13 16.5 13V15C18.43 15 20 13.43 20 11.5C20 9.57 18.43 8 16.5 8Z"
      fill="black"
      fillOpacity="0.54"
    />
  </svg>
);

export const FlitterIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.625 3.12441H0.71375C0.85017 3.6604 1.16129 4.13566 1.59795 4.47511C2.03461 4.81455 2.57192 4.99883 3.125 4.99883C3.67808 4.99883 4.21539 4.81455 4.65205 4.47511C5.08871 4.13566 5.39983 3.6604 5.53625 3.12441H18.125C18.2908 3.12441 18.4497 3.05857 18.5669 2.94136C18.6842 2.82415 18.75 2.66518 18.75 2.49942C18.75 2.33365 18.6842 2.17468 18.5669 2.05747C18.4497 1.94026 18.2908 1.87442 18.125 1.87442H5.53625C5.39983 1.33843 5.08871 0.863167 4.65205 0.523723C4.21539 0.184278 3.67808 0 3.125 0C2.57192 0 2.03461 0.184278 1.59795 0.523723C1.16129 0.863167 0.85017 1.33843 0.71375 1.87442H0.625C0.45924 1.87442 0.300268 1.94026 0.183058 2.05747C0.065848 2.17468 0 2.33365 0 2.49942C0 2.66518 0.065848 2.82415 0.183058 2.94136C0.300268 3.05857 0.45924 3.12441 0.625 3.12441ZM3.125 1.24942C3.37223 1.24942 3.6139 1.32273 3.81946 1.46008C4.02502 1.59743 4.18524 1.79265 4.27985 2.02106C4.37446 2.24947 4.39921 2.5008 4.35098 2.74328C4.30275 2.98575 4.1837 3.20848 4.00888 3.3833C3.83407 3.55811 3.61134 3.67717 3.36886 3.7254C3.12639 3.77363 2.87505 3.74887 2.64665 3.65426C2.41824 3.55965 2.22301 3.39944 2.08566 3.19388C1.94831 2.98832 1.875 2.74664 1.875 2.49942C1.875 2.16789 2.0067 1.84995 2.24112 1.61553C2.47554 1.38111 2.79348 1.24942 3.125 1.24942ZM18.125 8.12441H18.0362C17.8998 7.58842 17.5887 7.11317 17.1521 6.77372C16.7154 6.43428 16.1781 6.25 15.625 6.25C15.0719 6.25 14.5346 6.43428 14.0979 6.77372C13.6613 7.11317 13.3502 7.58842 13.2137 8.12441H0.625C0.45924 8.12441 0.300268 8.19026 0.183058 8.30747C0.065848 8.42468 0 8.58365 0 8.74941C0 8.91517 0.065848 9.07415 0.183058 9.19136C0.300268 9.30857 0.45924 9.37441 0.625 9.37441H13.2137C13.3502 9.9104 13.6613 10.3857 14.0979 10.7251C14.5346 11.0646 15.0719 11.2488 15.625 11.2488C16.1781 11.2488 16.7154 11.0646 17.1521 10.7251C17.5887 10.3857 17.8998 9.9104 18.0362 9.37441H18.125C18.2908 9.37441 18.4497 9.30857 18.5669 9.19136C18.6842 9.07415 18.75 8.91517 18.75 8.74941C18.75 8.58365 18.6842 8.42468 18.5669 8.30747C18.4497 8.19026 18.2908 8.12441 18.125 8.12441ZM15.625 9.99941C15.3778 9.99941 15.1361 9.9261 14.9305 9.78875C14.725 9.6514 14.5648 9.45618 14.4701 9.22777C14.3755 8.99936 14.3508 8.74803 14.399 8.50555C14.4472 8.26308 14.5663 8.04035 14.7411 7.86553C14.9159 7.69072 15.1387 7.57166 15.3811 7.52343C15.6236 7.4752 15.8749 7.49996 16.1034 7.59456C16.3318 7.68917 16.527 7.84939 16.6643 8.05495C16.8017 8.26051 16.875 8.50219 16.875 8.74941C16.875 9.08094 16.7433 9.39888 16.5089 9.6333C16.2745 9.86772 15.9565 9.99941 15.625 9.99941ZM18.125 14.3744H11.7862C11.6498 13.8384 11.3387 13.3632 10.9021 13.0237C10.4654 12.6843 9.92808 12.5 9.375 12.5C8.82192 12.5 8.28461 12.6843 7.84795 13.0237C7.41129 13.3632 7.10017 13.8384 6.96375 14.3744H0.625C0.45924 14.3744 0.300268 14.4403 0.183058 14.5575C0.065848 14.6747 0 14.8337 0 14.9994C0 15.1652 0.065848 15.3241 0.183058 15.4414C0.300268 15.5586 0.45924 15.6244 0.625 15.6244H6.96375C7.10017 16.1604 7.41129 16.6357 7.84795 16.9751C8.28461 17.3146 8.82192 17.4988 9.375 17.4988C9.92808 17.4988 10.4654 17.3146 10.9021 16.9751C11.3387 16.6357 11.6498 16.1604 11.7862 15.6244H18.125C18.2908 15.6244 18.4497 15.5586 18.5669 15.4414C18.6842 15.3241 18.75 15.1652 18.75 14.9994C18.75 14.8337 18.6842 14.6747 18.5669 14.5575C18.4497 14.4403 18.2908 14.3744 18.125 14.3744ZM9.375 16.2494C9.12777 16.2494 8.8861 16.1761 8.68054 16.0388C8.47497 15.9014 8.31476 15.7062 8.22015 15.4778C8.12554 15.2494 8.10079 14.998 8.14902 14.7556C8.19725 14.5131 8.3163 14.2903 8.49112 14.1155C8.66593 13.9407 8.88866 13.8217 9.13114 13.7734C9.37361 13.7252 9.62495 13.75 9.85335 13.8446C10.0818 13.9392 10.277 14.0994 10.4143 14.305C10.5517 14.5105 10.625 14.7522 10.625 14.9994C10.625 15.3309 10.4933 15.6489 10.2589 15.8833C10.0245 16.1177 9.70652 16.2494 9.375 16.2494Z"
        fill="#AB360F"
      />
    </svg>
  );
};

export const Close = (props) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};

export const Check = () => {
  return (
    <svg
      width="81"
      height="81"
      viewBox="0 0 81 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M74.25 17.4825L35.7413 56.025L21.4312 41.715L26.19 36.9562L35.7413 46.5075L69.4912 12.7575L74.25 17.4825ZM66.7913 34.4925C67.23 36.4163 67.5 38.4412 67.5 40.5C67.5 55.4175 55.4175 67.5 40.5 67.5C25.5825 67.5 13.5 55.4175 13.5 40.5C13.5 25.5825 25.5825 13.5 40.5 13.5C45.8325 13.5 50.76 15.0525 54.945 17.7188L59.805 12.8587C54.3375 9.01125 47.6888 6.75 40.5 6.75C21.87 6.75 6.75 21.87 6.75 40.5C6.75 59.13 21.87 74.25 40.5 74.25C59.13 74.25 74.25 59.13 74.25 40.5C74.25 36.4837 73.5075 32.6362 72.225 29.0587L66.7913 34.4925Z"
        fill="#2E7D6F"
      />
    </svg>
  );
};

export const InfoCircle = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};

export const Clock = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z"
        fill="black"
        fillOpacity="0.54"
      />
      <path
        d="M10.5 5H9V11L14.25 14.15L15 12.92L10.5 10.25V5Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};

export const Edit = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.499023 12.3771V15.5021H3.62402L12.8407 6.28542L9.71569 3.16042L0.499023 12.3771ZM15.2574 3.86875C15.5824 3.54375 15.5824 3.01875 15.2574 2.69375L13.3074 0.74375C12.9824 0.41875 12.4574 0.41875 12.1324 0.74375L10.6074 2.26875L13.7324 5.39375L15.2574 3.86875Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};

export const ArrowNext = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2049 6L8.79492 7.41L13.3749 12L8.79492 16.59L10.2049 18L16.2049 12L10.2049 6Z"
        fill="#0000008A"
      />
    </svg>
  );
};

export const LogoBlack = (props) => {
  return (
    <svg
      width="96"
      height="80"
      viewBox="0 0 96 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_8612_31594)">
        <path
          d="M30.2231 12.3096C30.2231 12.7568 30.0256 13.0062 29.6276 13.0578C29.5724 13.0664 21.8043 13.0693 21.7433 13.0693C21.6794 13.0693 21.2785 13.118 20.5377 13.2097C19.7969 13.3072 19.0097 13.5595 18.1759 13.9723C17.3422 14.3851 16.5694 15.0501 15.8635 15.9703C15.1576 16.8905 14.8032 18.2063 14.8032 19.9177V36.8454H29.4417C29.9559 36.8454 30.2144 37.069 30.2144 37.5104C30.2144 38.0207 29.9559 38.273 29.4417 38.273H14.8032V66.5096C14.8032 67.0199 14.5795 67.2721 14.1292 67.2721C13.615 67.2721 13.3594 67.0199 13.3594 66.5096V19.9206C13.3594 17.891 13.7922 16.3229 14.6579 15.2135C15.5265 14.1041 16.4765 13.2814 17.502 12.7396C18.5303 12.2007 19.948 11.8366 21.7433 11.6445C21.8043 11.6445 29.5695 11.6445 29.6218 11.6531C30.0256 11.699 30.226 11.9197 30.226 12.3096H30.2231Z"
          fill="#231F20"
        />
        <path
          d="M14.1277 68.9214C12.6897 68.9214 11.6875 67.9296 11.6875 66.5134V19.9215C11.6875 17.5307 12.2395 15.6101 13.3318 14.2083C14.3427 12.9183 15.4786 11.935 16.7132 11.2871C17.9479 10.6421 19.534 10.2236 21.5617 10.0086L21.7389 10C29.6494 10 29.7046 10.0057 29.8237 10.0229C31.0496 10.1605 31.8892 11.0807 31.8892 12.3134C31.8892 13.5461 31.0699 14.5293 29.8498 14.6956C29.7278 14.7128 29.6523 14.7214 21.797 14.7214C21.6489 14.7357 21.3003 14.7787 20.7483 14.8504C20.1993 14.9221 19.5834 15.1256 18.9181 15.4524C18.3197 15.7477 17.7358 16.2608 17.1867 16.9717C16.7103 17.5938 16.4663 18.5857 16.4663 19.9215V35.2008H29.4373C30.8753 35.2008 31.8775 36.1526 31.8775 37.5142C31.8775 38.8759 30.8724 39.9222 29.4373 39.9222H16.4663V66.5105C16.4663 67.9295 15.5018 68.9185 14.1248 68.9185L14.1277 68.9214Z"
          fill="#231F20"
        />
        <path
          d="M79.9611 11.7305C80.4753 11.7305 80.7339 11.9541 80.7339 12.3984V30.0857C80.606 31.1636 80.3794 32.1784 80.0599 33.1301C79.7374 33.9557 79.2552 34.7957 78.6132 35.6499C77.9712 36.507 77.0706 37.1893 75.9173 37.6938C77.0735 38.2012 78.1629 39.0268 79.1942 40.1678C80.2226 41.3087 80.7368 42.9914 80.7368 45.2102V66.5984C80.7368 67.1058 80.4782 67.3581 79.964 67.3581C79.4498 67.3581 79.1942 67.1058 79.1942 66.5984V45.2102C79.1942 43.4988 78.8398 42.183 78.1339 41.2628C77.4279 40.3455 76.6552 39.6776 75.8214 39.2648C74.9848 38.852 74.1975 38.5997 73.4596 38.5051C72.7218 38.4105 72.318 38.3618 72.254 38.3618H65.3139V66.6013C65.3139 67.1087 65.0873 67.361 64.637 67.361C64.1228 67.361 63.8672 67.1087 63.8672 66.6013V12.3984C63.8672 11.9541 64.1228 11.7305 64.637 11.7305C65.0873 11.7305 65.3139 11.9541 65.3139 12.3984V36.937H72.254C73.9884 36.937 75.3218 36.5902 76.2543 35.8907C77.1839 35.1941 77.8608 34.4316 78.2791 33.606C78.6974 32.7833 78.9531 32.0064 79.0518 31.2754C79.1477 30.5473 79.1942 30.1488 79.1942 30.0857V12.3984C79.1942 11.9541 79.4527 11.7305 79.964 11.7305H79.9611Z"
          fill="#231F20"
        />
        <path
          d="M79.9576 69.0074C78.5196 69.0074 77.5174 68.0184 77.5174 66.6022V45.214C77.5174 43.8782 77.2734 42.8863 76.794 42.2585C76.2479 41.5504 75.6669 41.0373 75.0626 40.7392C74.4003 40.4124 73.7815 40.2088 73.2325 40.14C72.6834 40.0684 72.3319 40.0254 72.1808 40.011H66.9721V66.6022C66.9721 68.0184 66.0076 69.0074 64.6277 69.0074C63.2478 69.0074 62.1875 68.0184 62.1875 66.6022V12.3993C62.1875 11.0377 63.1897 10.0859 64.6277 10.0859C66.0657 10.0859 66.9721 11.0377 66.9721 12.3993V35.2896H72.2418C73.5956 35.2896 74.6036 35.0517 75.2311 34.5787C75.9545 34.0369 76.4716 33.4607 76.7737 32.8702C77.1049 32.2194 77.3111 31.6117 77.3838 31.0613C77.4535 30.5224 77.4971 30.1755 77.5116 30.0293V12.3993C77.5116 11.0377 78.5138 10.0859 79.9518 10.0859C81.3898 10.0859 82.3921 11.0377 82.3921 12.3993L82.3804 30.2787C82.241 31.4569 81.9883 32.5893 81.6309 33.6499C81.2271 34.6876 80.6665 35.6652 79.9402 36.6341C79.6584 37.0125 79.336 37.3622 78.9757 37.6862C79.4754 38.0961 79.9576 38.5576 80.4224 39.0765C81.7268 40.5242 82.3892 42.591 82.3892 45.214V66.6022C82.3892 68.0184 81.384 69.0074 79.9489 69.0074H79.9576Z"
          fill="#231F20"
        />
        <path
          d="M54.4157 34.1814C54.7382 33.4848 54.9822 32.834 55.142 32.232C55.2988 31.63 55.4121 30.9162 55.4789 30.0906V20.0114C55.2872 18.237 54.9154 16.8266 54.3692 15.7774C53.826 14.731 52.9748 13.7793 51.8157 12.9222C50.7902 12.1654 49.3958 11.764 47.6731 11.6752C47.586 11.6637 47.5191 11.6465 47.4291 11.6379C47.3535 11.6379 39.3414 11.6264 39.2833 11.6379C38.8331 11.7669 38.6094 12.0192 38.6094 12.4004V66.5947C38.6094 66.976 38.8331 67.2311 39.2833 67.3573C39.3356 67.3659 47.4204 67.3573 47.4291 67.3573C47.5569 67.3458 47.6644 67.32 47.7777 67.3028C49.9071 67.1595 51.653 66.4715 52.9719 65.1729C53.611 64.5393 54.0932 63.8743 54.4128 63.1748C54.7353 62.4782 54.9793 61.8275 55.1391 61.2255C55.2959 60.6235 55.4092 59.9097 55.476 59.0841V45.2123C55.476 42.9935 54.9589 41.3107 53.9306 40.1698C52.9051 39.0289 51.8128 38.2062 50.6566 37.6959C51.5542 37.3146 52.327 36.8101 52.9719 36.1737C53.611 35.5402 54.0932 34.8751 54.4128 34.1756L54.4157 34.1814ZM52.8731 41.2677C53.5791 42.1879 53.9335 43.5037 53.9335 45.2151V59.0869C53.9335 59.6574 53.8376 60.2623 53.6459 60.8958C53.518 61.4061 53.3234 61.9421 53.0649 62.5126C52.8092 63.0831 52.4228 63.6249 51.9087 64.1294C50.6885 65.3334 49.0501 65.9354 46.9962 65.9354C46.9904 65.9354 41.4156 65.8322 40.059 65.8207V38.3638H46.9962C47.0572 38.3638 47.461 38.4126 48.2018 38.5072C48.9397 38.6018 49.727 38.8569 50.5607 39.2668C51.3974 39.6796 52.1701 40.3447 52.876 41.2649L52.8731 41.2677ZM46.9933 36.8445H40.0561V13.1773C41.3721 13.163 44.4979 13.1744 46.1886 13.1744C46.1886 13.1859 47.0689 13.1744 47.1589 13.1744C48.809 13.1974 50.093 13.5385 50.9965 14.2122C51.9261 14.9088 52.6001 15.6713 53.0184 16.4969C53.4338 17.3196 53.6923 18.0965 53.7911 18.8275C53.887 19.5556 53.9335 19.9541 53.9335 20.0172V30.0964C53.9335 30.6668 53.8376 31.2717 53.6459 31.9052C53.518 32.4126 53.3234 32.9516 53.0649 33.522C52.8092 34.0925 52.4228 34.6314 51.9087 35.1388C50.7524 36.2798 49.1169 36.8502 46.9962 36.8502L46.9933 36.8445Z"
          fill="#231F20"
        />
        <path
          d="M41.6108 69.0104C39.159 69.0104 39.1125 69.0018 38.9788 68.976L38.8278 68.9416C37.6658 68.6148 36.9453 67.7147 36.9453 66.5967V12.4024C36.9453 11.2872 37.6658 10.3871 38.8249 10.0574L38.9353 10.0316C39.0883 9.99915 41.8665 9.98673 47.2698 9.99437L47.6155 10.0058C47.7056 10.0144 47.784 10.0288 47.8625 10.0431C49.9018 10.1606 51.5693 10.6881 52.8185 11.6083C54.178 12.6145 55.1977 13.764 55.8571 15.0282C56.505 16.2724 56.9262 17.8462 57.1412 19.8385L57.1499 20.0134L57.1441 30.2244C57.0685 31.1418 56.9407 31.9559 56.7577 32.6468C56.5747 33.3348 56.3074 34.0572 55.9385 34.8627C55.5376 35.7341 54.9391 36.5683 54.1606 37.3423C54.0328 37.4685 53.8991 37.5917 53.7626 37.7093C54.2535 38.1135 54.7271 38.5721 55.1861 39.0795C56.4904 40.5272 57.1528 42.5941 57.1528 45.2171L57.147 59.2207C57.0714 60.1381 56.9436 60.9522 56.7606 61.6431C56.5776 62.3339 56.3103 63.0592 55.9385 63.8619C55.5405 64.7305 54.942 65.5647 54.1606 66.3387C52.5919 67.8838 50.5148 68.7553 47.9816 68.9445C47.8218 68.9731 47.7172 68.9875 47.601 68.9989L47.4354 69.0075C44.6785 69.0104 42.8425 69.0133 41.6137 69.0133L41.6108 69.0104ZM41.7299 64.1915C44.9458 64.2202 46.3315 64.2489 46.9997 64.3005V64.2919C48.6091 64.2919 49.8321 63.859 50.7326 62.9675C51.1016 62.6034 51.3747 62.2279 51.5431 61.8495C51.7639 61.365 51.9266 60.9121 52.0312 60.4964C52.1968 59.9489 52.2694 59.5017 52.2694 59.0889V45.2171C52.2694 43.8783 52.0283 42.8865 51.549 42.2644C51.0028 41.5535 50.4218 41.0432 49.8175 40.7451C49.1552 40.4183 48.5393 40.2147 47.9903 40.1459C47.4412 40.0743 47.0897 40.0313 46.9387 40.0169H41.7328V64.1944L41.7299 64.1915ZM41.7299 35.1981H46.9997C48.673 35.1981 49.8931 34.7939 50.7326 33.9683C51.1016 33.6042 51.3747 33.2287 51.5431 32.8532C51.7639 32.3658 51.9266 31.9158 52.0312 31.5001C52.1968 30.9554 52.2694 30.5054 52.2694 30.0926V20.0707C52.2549 19.9245 52.2113 19.5776 52.1416 19.033C52.069 18.4969 51.8627 17.8892 51.5315 17.2298C51.2294 16.6393 50.7123 16.0631 49.9919 15.5213C49.3934 15.0741 48.4348 14.839 47.1449 14.8218C46.7527 14.8247 46.4477 14.8276 46.1979 14.819V14.8247H44.5188C43.6037 14.8247 42.6043 14.819 41.7357 14.8218V35.2038L41.7299 35.1981Z"
          fill="#231F20"
        />
        <path
          d="M10.2911 79.1789C9.31789 79.1789 8.6875 78.5568 8.6875 77.5936C8.6875 76.6878 9.31789 76.1058 10.2911 76.1058H85.95C87.4897 76.1058 88.6662 75.8106 89.4477 75.2258C90.2698 74.6094 90.8682 73.9386 91.2285 73.2306C91.6003 72.4967 91.8327 71.8001 91.9169 71.1608C92.0012 70.5216 92.0477 70.1489 92.0564 70.0457C92.0564 70.0027 92.0564 62.343 92.068 62.2255C92.1842 61.3827 92.7943 60.8867 93.66 60.8867C94.5257 60.8867 95.0573 61.3941 95.1561 62.2111C95.1619 62.2541 95.1706 62.3172 95.1706 70.0801L95.1648 70.169C94.9614 72.0409 94.5576 73.5516 93.965 74.6524C93.3666 75.7647 92.4457 76.7967 91.2314 77.7226C89.9619 78.6887 88.184 79.1789 85.95 79.1789H10.2911Z"
          fill="#F15B29"
        />
        <path
          d="M93.6578 61.708C94.0529 61.708 94.2766 61.9058 94.323 62.3042C94.3288 62.353 94.3318 70.0184 94.3318 70.0786C94.14 71.8531 93.7682 73.2492 93.2249 74.264C92.6788 75.2788 91.8421 76.2133 90.7179 77.0704C89.5936 77.9247 88.0017 78.3547 85.9478 78.3547H10.2889C9.7747 78.3547 9.51906 78.0995 9.51906 77.595C9.51906 77.1507 9.7747 76.9299 10.2889 76.9299H85.9478C87.6821 76.9299 89.0155 76.5831 89.948 75.8836C90.8777 75.187 91.5516 74.4274 91.97 73.6018C92.3883 72.779 92.6439 71.9993 92.7398 71.2712C92.8357 70.543 92.885 70.1474 92.885 70.0844C92.885 70.0213 92.8909 62.3558 92.8938 62.3014C92.949 61.9086 93.2017 61.7137 93.6549 61.7137M93.6578 60.0625C92.3825 60.0625 91.4122 60.868 91.2437 62.0692L91.2379 62.1093V62.1494C91.2176 62.3186 91.2176 68.5937 91.2176 70.0156C91.203 70.1618 91.1595 70.5086 91.0868 71.0504C91.0142 71.598 90.8109 72.2057 90.4797 72.8564C90.1776 73.4498 89.6604 74.0231 88.94 74.5649C88.3096 75.0379 87.3016 75.2759 85.9478 75.2759H10.2889C8.8538 75.2759 7.85156 76.2276 7.85156 77.5893C7.85156 78.951 8.8538 79.9973 10.2889 79.9973H85.9478C88.3706 79.9973 90.3199 79.4498 91.7376 78.3719C93.0477 77.3714 94.0442 76.2506 94.6978 75.0351C95.3514 73.8225 95.7756 72.2573 95.9905 70.2535L95.9993 70.1675V70.0786C95.9993 62.2612 95.9934 62.2268 95.976 62.095C95.8337 60.8881 94.8982 60.0625 93.6549 60.0625H93.6578Z"
          fill="#F15B29"
        />
        <path
          d="M2.34656 19.1125C1.52153 19.1125 0.949234 18.6051 0.850463 17.7881C0.844653 17.7451 0.835938 17.682 0.835938 9.91911L0.841748 9.83024C1.0451 7.95831 1.4489 6.45044 2.04153 5.34678C2.64287 4.23451 3.56087 3.19964 4.77517 2.27371C6.04468 1.30765 7.82256 0.820312 10.0565 0.820312H85.7154C86.6915 0.820312 87.3219 1.44238 87.3219 2.40558C87.3219 3.31144 86.6915 3.89338 85.7154 3.89338H10.0565C8.51687 3.89338 7.34033 4.18864 6.56177 4.77344C5.73674 5.38978 5.1383 6.06057 4.77808 6.76864C4.40623 7.50824 4.17383 8.20484 4.08958 8.83837C4.00534 9.47764 3.95886 9.84744 3.95014 9.9535C3.95014 15.0648 3.94433 17.7164 3.93562 17.8024C3.81942 18.6166 3.21226 19.1154 2.34656 19.1154V19.1125Z"
          fill="#F15B29"
        />
        <path
          d="M85.7133 1.64443C86.2274 1.64443 86.4831 1.89669 86.4831 2.40409C86.4831 2.84842 86.2274 3.06916 85.7133 3.06916H10.0543C8.32004 3.06916 6.98663 3.41602 6.05411 4.11549C5.12449 4.81209 4.44762 5.57176 4.02929 6.39736C3.61097 7.22295 3.35532 7.99982 3.25946 8.72795C3.16359 9.45609 3.1142 9.85168 3.1142 9.91762C3.1142 9.97782 3.1113 17.6461 3.10549 17.6977C3.05029 18.0905 2.79756 18.2854 2.34437 18.2854C1.94928 18.2854 1.72559 18.0876 1.67911 17.6891C1.6733 17.6404 1.6704 9.97495 1.6704 9.91762C1.86213 8.14315 2.23398 6.74709 2.78012 5.73229C3.32627 4.71749 4.16293 3.78296 5.28718 2.92582C6.41143 2.07156 8.00339 1.64443 10.0573 1.64443H85.7162M85.7133 -0.00103959H10.0543C7.63155 -0.00103959 5.68517 0.546493 4.2646 1.62436C2.95443 2.62196 1.9609 3.74569 1.30436 4.96116C0.650729 6.17662 0.226593 7.74182 0.00871513 9.74562L0 9.83162V9.92048C0 17.7379 0.00581008 17.7723 0.0232403 17.9041C0.165587 19.111 1.10101 19.9366 2.34437 19.9366C3.58773 19.9366 4.58997 19.1282 4.75846 17.9271C4.77589 17.7952 4.7846 17.7178 4.7846 9.97782C4.79913 9.83162 4.8427 9.48475 4.91533 8.94295C4.98796 8.40115 5.19131 7.79055 5.52539 7.13409C5.82461 6.54355 6.34461 5.97022 7.06506 5.42842C7.69546 4.95542 8.7006 4.71749 10.0573 4.71749H85.7162C87.1513 4.71749 88.1564 3.76576 88.1564 2.40409C88.1564 1.04243 87.1542 -0.00390625 85.7162 -0.00390625L85.7133 -0.00103959Z"
          fill="#F15B29"
        />
        <path
          d="M30.0313 25.8261C30.0313 28.6498 27.713 30.9374 24.8516 30.9374C21.9901 30.9374 19.6719 28.6498 19.6719 25.8261C19.6719 23.0024 21.9901 20.7148 24.8516 20.7148C27.713 20.7148 30.0313 23.0024 30.0313 25.8261Z"
          fill="#F15B29"
        />
        <path
          d="M24.8523 31.7615C21.5347 31.7615 18.8359 29.0984 18.8359 25.8275C18.8359 22.5566 21.5347 19.8906 24.8523 19.8906C28.1698 19.8906 30.8657 22.5538 30.8657 25.8275C30.8657 29.1012 28.1669 31.7615 24.8523 31.7615ZM24.8523 21.539C22.4556 21.539 20.5063 23.4625 20.5063 25.8275C20.5063 28.1925 22.4556 30.116 24.8523 30.116C27.2489 30.116 29.1982 28.1925 29.1982 25.8275C29.1982 23.4625 27.2489 21.539 24.8523 21.539Z"
          fill="#F7941D"
        />
        <path
          d="M30.0313 52.4003C30.0313 55.224 27.713 57.5116 24.8516 57.5116C21.9901 57.5116 19.6719 55.224 19.6719 52.4003C19.6719 49.5767 21.9901 47.2891 24.8516 47.2891C27.713 47.2891 30.0313 49.5767 30.0313 52.4003Z"
          fill="#F15B29"
        />
        <path
          d="M24.8523 58.3357C21.5347 58.3357 18.8359 55.6726 18.8359 52.4017C18.8359 49.1308 21.5347 46.4648 24.8523 46.4648C28.1698 46.4648 30.8657 49.128 30.8657 52.4017C30.8657 55.6754 28.1669 58.3357 24.8523 58.3357ZM24.8523 48.1132C22.4556 48.1132 20.5063 50.0367 20.5063 52.4017C20.5063 54.7667 22.4556 56.6902 24.8523 56.6902C27.2489 56.6902 29.1982 54.7667 29.1982 52.4017C29.1982 50.0367 27.2489 48.1132 24.8523 48.1132Z"
          fill="#F7941D"
        />
      </g>
      <defs>
        <clipPath id="clip0_8612_31594">
          <rect width="96" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const GeneralDetail = (props) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 18V4L10 0L0 4V18H5V9H15V18H20ZM9 16H7V18H9V16ZM11 13H9V15H11V13ZM13 16H11V18H13V16Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};

export const SalesUSer = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.5 5.00063C10.2885 4.65871 11.1407 4.48828 12 4.50063C12.8593 4.48828 13.7115 4.65871 14.5 5.00063"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 7V5.5C16 4 16 2.5 12 2.5C8 2.5 8 4 8 5.5V7"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="10.5" cy="9" r="0.5" fill="black" fillOpacity="0.54" />
      <circle cx="13.5" cy="9" r="0.5" fill="black" fillOpacity="0.54" />
      <path
        d="M12 16C11.4067 16 10.8266 16.1759 10.3333 16.5056C9.83994 16.8352 9.45543 17.3038 9.22836 17.8519C9.0013 18.4001 8.94189 19.0033 9.05765 19.5853C9.1734 20.1672 9.45912 20.7018 9.87868 21.1213C10.2982 21.5409 10.8328 21.8266 11.4147 21.9424C11.9967 22.0581 12.5999 21.9987 13.1481 21.7716C13.6962 21.5446 14.1648 21.1601 14.4944 20.6667C14.8241 20.1734 15 19.5933 15 19C15 18.2044 14.6839 17.4413 14.1213 16.8787C13.5587 16.3161 12.7957 16 12 16Z"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 18.4922L11.5 19.4922L13 17.9922"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M2.5 19.5V17.56C2.49922 17.116 2.64621 16.6844 2.91779 16.3331C3.18937 15.9819 3.57011 15.731 4 15.62L8.5 14.5"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5 19.5V17.56C21.5008 17.116 21.3538 16.6844 21.0822 16.3331C20.8106 15.9819 20.4299 15.731 20 15.62L15.5 14.5"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 9C7.5 9.32082 7.59496 9.63445 7.77292 9.90139C7.95087 10.1683 8.20386 10.3766 8.5 10.5V11C8.5 12.655 10.345 14 12 14C13.655 14 15.5 12.655 15.5 11V10.5C15.7961 10.3766 16.0491 10.1683 16.2271 9.90139C16.405 9.63445 16.5 9.32082 16.5 9"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ClearIcon = () => {
  return (
    <svg
      class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1s0hah4"
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      data-testid="ClearIcon"
    >
      <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
    </svg>
  );
};

export const Contract = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5 8.5V3C16.5 2.86739 16.4473 2.74021 16.3536 2.64645C16.2598 2.55268 16.1326 2.5 16 2.5H3C2.86739 2.5 2.74021 2.55268 2.64645 2.64645C2.55268 2.74021 2.5 2.86739 2.5 3V21C2.5 21.1326 2.55268 21.2598 2.64645 21.3536C2.74021 21.4473 2.86739 21.5 3 21.5H16C16.1326 21.5 16.2598 21.4473 16.3536 21.3536C16.4473 21.2598 16.5 21.1326 16.5 21V19.5"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 10C16.7089 10 15.9355 10.2346 15.2777 10.6741C14.6199 11.1136 14.1072 11.7384 13.8045 12.4693C13.5017 13.2002 13.4225 14.0044 13.5769 14.7804C13.7312 15.5563 14.1122 16.269 14.6716 16.8284C15.231 17.3878 15.9437 17.7688 16.7196 17.9231C17.4956 18.0775 18.2998 17.9983 19.0307 17.6955C19.7616 17.3928 20.3864 16.8801 20.8259 16.2223C21.2654 15.5645 21.5 14.7911 21.5 14C21.5 12.9391 21.0786 11.9217 20.3284 11.1716C19.5783 10.4214 18.5609 10 17.5 10Z"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M5 6H14"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M5 8H14"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M5 10H14"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M5 12H14"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M5 14H13.5"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 13.5L17 15L19.5 12.5"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M5 18.5C5 18.5 5.38 16 7 16C8.355 16 7.63 18.41 7.63 18.41C7.63 18.41 8.13 16.1 9.63 16.36C10.795 16.555 10.16 18.435 10.16 18.435C10.16 18.435 10.855 16.935 12.08 16.435"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UserIconB = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.0026 7.00065C8.84427 7.00065 10.3359 5.50898 10.3359 3.66732C10.3359 1.82565 8.84427 0.333984 7.0026 0.333984C5.16094 0.333984 3.66927 1.82565 3.66927 3.66732C3.66927 5.50898 5.16094 7.00065 7.0026 7.00065ZM7.0026 8.66732C4.7776 8.66732 0.335938 9.78398 0.335938 12.0007V13.6673H13.6693V12.0007C13.6693 9.78398 9.2276 8.66732 7.0026 8.66732Z"
        fill="rgba(0, 0, 0, 0.54)"
      />
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM8.46 11.88L9.87 10.47L12 12.59L14.12 10.47L15.53 11.88L13.41 14L15.53 16.12L14.12 17.53L12 15.41L9.88 17.53L8.47 16.12L10.59 14L8.46 11.88ZM15.5 4L14.5 3H9.5L8.5 4H5V6H19V4H15.5Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};

export const UpArrow = (props) => {
  return (
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 0.296875L0 6.29688L1.41 7.70687L6 3.12687L10.59 7.70687L12 6.29688L6 0.296875Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};

export const Cancel = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59L13.59 5L15 6.41L11.41 10L15 13.59Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const BackArrow = ({ fillOpacity, ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z"
        fill="black"
        fillOpacity={fillOpacity ?? "0.54"}
        {...props}
      />
    </svg>
  );
};
export const WarningIcon = ({ fillOpacity, ...props }) => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.o
      rg/2000/svg"
      {...props}
    >
      <path
        d="M11 4.49L18.53 17.5H3.47L11 4.49ZM11 0.5L0 19.5H22L11 0.5Z"
        fill="black"
        fillOpacity="0.54"
      />
      <path d="M12 14.5H10V16.5H12V14.5Z" fill="black" fillOpacity="0.54" />
      <path d="M12 8.5H10V13.5H12V8.5Z" fill="black" fillOpacity="0.54" />
    </svg>
  );
};
